import {useState} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {CategoryModal} from './CategoryModal'

type Props = {
  onSearchChange: (search: string) => void
  onStatusChange: (status: string) => void
  onTrashChange: (trashStatus: string) => void
  onReload: () => void
}

const CategoriesListHeader = ({onSearchChange, onStatusChange, onTrashChange, onReload}: Props) => {
  const [showModal, setShowModal] = useState(false)
  const [editingCategory, setEditingCategory] = useState<any>(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [status, setStatus] = useState('')
  const [trashStatus, setTrashStatus] = useState('without_trash')

  const openAddModal = () => {
    setEditingCategory(null)
    setShowModal(true)
  }

  const handleSearchChange = (value: string) => {
    setSearchTerm(value)
    onSearchChange(value)
  }

  const handleStatusChange = (value: string) => {
    setStatus(value)
    onStatusChange(value)
  }

  const handleTrashChange = (value: string) => {
    setTrashStatus(value)
    onTrashChange(value)
  }

  const handleReset = () => {
    setSearchTerm('')
    setStatus('')
    setTrashStatus('without_trash')
    onSearchChange('')
    onStatusChange('')
    onTrashChange('without_trash')
  }

  return (
    <>
      <div className='card-header border-0 pt-6'>
        {/* begin::Card title */}
        <div className='card-title'>
          {/* begin::Search */}
          <div className='d-flex align-items-center position-relative my-1'>
            <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
            <input
              type='text'
              data-kt-category-table-filter='search'
              className='form-control form-control-solid w-250px ps-14'
              placeholder='Search categories...'
              value={searchTerm}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
          </div>
          {/* end::Search */}
        </div>
        {/* end::Card title */}
        {/* begin::Card toolbar */}
        <div className='card-toolbar'>
          <div
            className='d-flex justify-content-end align-items-center gap-2'
            data-kt-category-table-toolbar='base'
          >
            {/* begin::Status Filter */}
            <select
              className='form-select form-select-solid w-150px'
              value={status}
              onChange={(e) => handleStatusChange(e.target.value)}
            >
              <option value=''>All Status</option>
              <option value='Active'>Active</option>
              <option value='Inactive'>Inactive</option>
            </select>
            {/* end::Status Filter */}

            {/* begin::Trash Filter */}
            <select
              className='form-select form-select-solid w-180px'
              value={trashStatus}
              onChange={(e) => handleTrashChange(e.target.value)}
            >
              <option value='without_trash'>Without Trashed</option>
              <option value='with_trashed'>With Trashed</option>
              <option value='trashed'>Only Trashed</option>
            </select>
            {/* end::Trash Filter */}

            {/* begin::Reset */}
            {(searchTerm || status || trashStatus !== 'without_trash') && (
              <button type='button' className='btn btn-light-primary' onClick={handleReset}>
                <KTIcon iconName='cross' className='fs-2' />
                Reset
              </button>
            )}
            {/* end::Reset */}

            {/* begin::Add Category */}
            <button type='button' className='btn btn-primary' onClick={openAddModal}>
              <KTIcon iconName='plus' className='fs-2' />
              Add Category
            </button>
            {/* end::Add Category */}
          </div>
        </div>
        {/* end::Card toolbar */}
      </div>

      {showModal && (
        <CategoryModal
          category={editingCategory}
          onClose={() => setShowModal(false)}
          onSave={() => {
            setShowModal(false)
            onReload()
          }}
        />
      )}
    </>
  )
}

export {CategoriesListHeader}
